import React from 'react';
import PropTypes from 'prop-types';

import { includes } from 'lodash';

import withMessages from 'component-utilities/intl';

import styles from './Search.scss';

const BASE_KEY = 'components.search.tabs';

const TABS = {
    SIMPLE: 'simple',
    ADVANCED: 'advanced',
};

export { TABS };

function SearchToolComponent({ children, activeTab, getMessage, onTabSelect, disabledTabs }) {
    function isDisabledTab(tabKey) {
        return includes(disabledTabs, tabKey);
    }

    function tabStatus(tabKey) {
        if (isDisabledTab(tabKey)) {
            return 'disabled';
        } else if (activeTab !== tabKey) {
            return 'inactive';
        }

        return 'active';
    }

    function onTabClick(tabKey) {
        return () => {
            if (!isDisabledTab(tabKey)) {
                onTabSelect(tabKey);
            }
        };
    }

    return (
        <div className={styles['search-tool']}>
            <div className={styles['search-tabs']}>
                {[TABS.SIMPLE, TABS.ADVANCED].map(tabKey => (
                    <div
                        key={tabKey}
                        role="presentation"
                        data-action={`select-${tabKey}`}
                        onClick={onTabClick(tabKey)}
                        className={styles[`search-tab-${tabStatus(tabKey)}`]}
                    >
                        {getMessage(`${BASE_KEY}.${tabKey}`)}
                    </div>
                ))}
            </div>
            {children}
        </div>
    );
}

SearchToolComponent.propTypes = {
    children: PropTypes.node.isRequired,
    onTabSelect: PropTypes.func.isRequired,
    getMessage: PropTypes.func.isRequired,
    activeTab: PropTypes.oneOf([TABS.SIMPLE, TABS.ADVANCED]).isRequired,
    disabledTabs: PropTypes.array,
};

SearchToolComponent.defaultProps = {
    activeTab: TABS.SIMPLE,
    disabledTabs: [],
};

const SearchTool = withMessages(SearchToolComponent);

export default SearchTool;
